import React from 'react';
import { useFormContext, useController } from 'react-hook-form';

import { CheckboxGroup as CheckboxGroupBase, ICheckboxGroupProps } from '../../checkbox-group';
import { TFormExtendedProps, IAdditionalFormProps } from '..';

export const CheckboxGroup = ({
  name,
  helperText,
  ...props
}: TFormExtendedProps<ICheckboxGroupProps>): JSX.Element => {
  const { control, formState: { errors } } = useFormContext();
  const {
    field: { ref, ...restField },
    fieldState: { invalid },
  } = useController({
    name,
    control,
  });
  const additionalProps: IAdditionalFormProps = {};

  if (invalid) {
    additionalProps.error = true;
    additionalProps.helperText = errors[name]?.message;
  } else if (helperText) {
    additionalProps.helperText = helperText;
  }

  return (
    <CheckboxGroupBase
      {...props}
      {...restField}
      {...additionalProps}
    />
  );
};
